import { createContext } from "react";

export const userPostPaymentCheck = function data(post_id, userPaymentData) {
  return userPaymentData?.includes(post_id);
};

export const FollowContext = createContext({});
export const WalletContext = createContext({});
export const LocationContext = createContext({});

export const FanGroupContext = createContext({});
